<pt-dialog-content class="!py-6">
  <pr-appointment-selector />
</pt-dialog-content>
